import { lazy } from 'react';

// project imports
import MinimalLayout from 'layout/MinimalLayout';
import Loadable from 'ui-component/Loadable';

// Deliberately unguarded (no GuestGuard): the impersonation handoff must be
// reachable while a session already exists — GuestGuard would bounce to the
// dashboard before the code in the fragment is read.
const SupportLogin = Loadable(lazy(() => import('views/auth/SupportLogin')));

// ==============================|| AUTHENTICATION ROUTING ||============================== //

const AuthenticationRoutes = {
    path: '/',
    element: <MinimalLayout />,
    children: [
        {
            path: '/support-login',
            element: <SupportLogin />
        }
    ]
};

export default AuthenticationRoutes;
